module.exports = __webpack_public_path__ + "img/three1Orange.b7c74f04.jpg";